/**
 * Der Vertrag zwischen Server (server/daten-export-routen.ts) und Seite „Deine Daten“ (Einstellungen → Du).
 * (17.10.2026, Plan scratchpad/export-deine-daten-plan.md, Bahn A1)
 *
 * Bahn B baut die Seite gegen DIESE Datei. Der Block bis zu den Konstanten steht wörtlich so im Plan —
 * nicht umbenennen, nicht umordnen. Zusätze stehen darunter.
 */
export type ExportTeil = "texte" | "mediathek" | "aufnahmen";
export type ExportStatus = "wartet" | "laeuft" | "fertig" | "fehler";
export interface ExportStand {
  id: string | null; status: ExportStatus | "keiner";
  teile: Array<{ teil: ExportTeil; dateien: Array<{ name: string; bytes: number; url: string }> }>;
  fortschritt: { erledigt: number; gesamt: number } | null;
  angelegtAm: string | null; verfaelltAm: string | null; fehler: string | null;
}
export interface DatenUebersicht { bereiche: Array<{ kennung: string; titel: string; anzahl: number; bytes: number; ort: string }>; sicherungTage: 30; stand: string }
export const EXPORT_VERFALL_H = 24; export const EXPORT_MAX_JE_TAG = 3; export const AUFNAHMEN_TEIL_MAX_BYTES = 2 * 1024 ** 3;

/* ------------------------------------------------------------------ */
/* Zusätze (Bahn A) — die Wege und der Schutzkopf                        */
/* ------------------------------------------------------------------ */

/** Die Adressen unter /api/daten (alle nur mit Sitzungs-Cookie). */
export const DATEN_PFAD_UEBERSICHT = "/api/daten/uebersicht";
export const DATEN_PFAD_EXPORT = "/api/daten/export";
export const DATEN_PFAD_KONTO_LOESCHUNG = "/api/daten/konto-loeschung-anfragen";

/**
 * CSRF-Schranke für die schreibenden Aufrufe (POST/DELETE): Kopf `x-vespera-aktion: daten-export` UND
 * `Content-Type: application/json` (auch beim DELETE und beim POST ohne Inhalt: Body `{}`). Das Lesen (GET) braucht ihn nicht.
 */
export const DATEN_KOPF = "x-vespera-aktion";
export const DATEN_KOPF_WERT = "daten-export";

/** Die festen Sätze, die der Server in `ExportStand.fehler` schreibt (nie ein freier Systemtext). */
export const EXPORT_FEHLER = ["zu wenig Platz", "Archiv fehlgeschlagen", "Server neu gestartet", "Export fehlgeschlagen"] as const;
